import { Injectable } from '@angular/core';
import { MainActions, PhoneApiService } from '@main/phone/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class PhoneEffects {
  loadPhone$: Observable<MainActions.PhoneLoadSuccess | MainActions.PhoneLoadFail> = createEffect(() =>
    this.actions$.pipe(
      ofType(MainActions.LOAD_PHONE),
      map((action: MainActions.PhoneLoad) => action.payload),
      switchMap((baseStoreCode) => {
        return this.phoneApiService.getPhone(baseStoreCode).pipe(
          map((res: string) => {
            return new MainActions.PhoneLoadSuccess(res);
          }),
          catchError((error: unknown) => of(new MainActions.PhoneLoadFail(error))),
        );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private phoneApiService: PhoneApiService,
  ) {}
}
